import get from 'lodash/get';
import { subScriptionProductAvailable } from '@helpers/customHooks/useEntitlements';
import { getSupportedCountryCode, getSupportedLanguageCode, getLanguageCode } from '@helpers/languages';
import { ProfileDetails, ProfileInfo } from '@customTypes/ItemTypes';
import { getProfileInfo, updateProfileInfo } from '@factories/profile';
import { setEBDashboardSettings } from './accountSettingsActions';

export const SET_PROFILE_DETAILS = 'SET_PROFILE_DETAILS';

export function setProfileDetails(value: ProfileDetails): { type: string; profileDetails: ProfileDetails } {
    return {
        type: SET_PROFILE_DETAILS,
        profileDetails: value
    };
}
export function getProfileDetails() {
    return (dispatch: any) => getProfileInfo()
        .then(
            (data) => {
                if (data) {
                    const address = (data.street) ? data.street.split(', ') : [''];

                    // This is to fix production issue where language code not setting up corretly in Idaas
                    let finalLanguagePreference = 'en-us';
                    if (data?.language_preference_code) {
                        if (data?.language_preference_code.length === 5) {
                            finalLanguagePreference = data?.language_preference_code;
                        }
                        else if (data?.country_code) {
                            finalLanguagePreference = `${data?.language_preference_code}-${data?.country_code}`;
                        }
                        else {
                            finalLanguagePreference = window.localStorage.getItem('language') || 'en-us';
                        }
                    }
                    else {
                        finalLanguagePreference = getLanguageCode();
                    }

                    dispatch(setProfileDetails(
                        {
                            userName: data.user_name || '',
                            email: data.email_address || '',
                            firstName: data.first_name || '',
                            lastName: data.last_name || '',
                            phoneNumber: data.phone_number || '',
                            countryCode: getSupportedCountryCode(data.country_code), // User profile country code is null or invalid set default to US
                            accountSettingsSSOLink: get(data, 'account_settings_sso_link', '') || '',
                            hasSubscription: data.has_subscription || '',
                            hasDashboard: (data.applications.findIndex((e: string) => e === 'EB Dashboard') !== -1),
                            languagePreference:
                                getSupportedLanguageCode(finalLanguagePreference?.toLowerCase())
                                || `en-${getSupportedCountryCode(data.country_code)?.toLowerCase() || 'us'}`, // If User profile language preference is null or unavailable, default to en-countryCode or en-us
                            product_subscriptions: data.product_subscriptions,
                            // Extra  fields required for user ERB Request
                            street: data.street || '',
                            city: data.city || '',
                            state: data.state || '',
                            postalCode: data.postal_code || '',
                            address1: address[0] || '',
                            address2: (address.length > 1) ? address[1] : '',
                            company_name: data.company_name,
                            title_code: data.title_code,
                            idaasUUID: data.idaasUUID,
                            isDnbUser: (data.email_address.toLowerCase().indexOf('@dnb.com') > -1)
                        }
                    ));
                    const products_list = data.product_subscriptions.map((product: { product_name :string}) => product.product_name);
                    if (window.digitalData) {
                        window.digitalData.page.userInfo = {
                            first_name: data.first_name,
                            last_name: data.last_name,
                            email_address: data.email_address,
                            products_list
                        };
                    }

                    dispatch(setEBDashboardSettings((data.applications.findIndex((e: any) => e === 'EB Dashboard') !== -1)));
                    /*  253 : 'D&B Rev.Up Now',//ZETA
                    231 : 'D&B Rev.Up ABX for Web Essential',//SSVI
                    216 : 'Analytics STD Trial'
                    294 : 'CIUKIFree //Credit Insights'
                    Send app_id to get only specific product expiration dates
                    to check tile label with days left, expired etc.. */
                    const productSubscriptions = ['216', '231', '253', '294'];
                    const subScriptionData = data?.product_subscriptions
                        ?.filter((product: any) => product.subscriber_number && productSubscriptions.includes(product.app_id));
                    if (subScriptionData.length) {
                        subScriptionProductAvailable(subScriptionData, dispatch);
                    }
                }
            }
        );
}

export function updateProfileDetails(profileJson: ProfileInfo) {
    return (dispatch: any) => updateProfileInfo(profileJson)
        .then(
            (updatedJson:any) => dispatch(setProfileDetails(updatedJson))
        );
}
